import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { SiteSettingsProvider } from './context/SiteSettingsContext';
import { CartWishlistProvider } from './context/CartWishlistContext';
import { LanguageProvider } from './context/LanguageContext';
import AppRoutes from './app/routes';
import ScrollToTop from './components/common/ScrollToTop';
import './styles/reset.css';
import './styles/variables.css';
import './styles/global.css';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <LanguageProvider>
          <SiteSettingsProvider>
            <CartWishlistProvider>
              <AppRoutes />
            </CartWishlistProvider>
          </SiteSettingsProvider>
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
